<se-fe-card>
  <se-fe-card-header class="overview-header"
    seFeDataTitle="Overview">
    <div seFeCardHeaderActions>
      @if (tabs?.[tabs.selected]?.hasResults) {
        <se-fe-button (click)="viewAll()">View {{ tabs?.[tabs.selected]?.title }}</se-fe-button>
      }
    </div>
  </se-fe-card-header>
  <se-fe-card-content>
    <se-fe-tab-group class="overview-tab-group">
      @for (key of tabKeys; track key) {
        <se-fe-tab-item class="overview-card-tab">
          <a [seFeTab]="tabs.selected === key" (click)="switchTab(key)" (keydown)="onKeydown(key, $event)">{{ key | titlecase }}</a>
        </se-fe-tab-item>
      }
    </se-fe-tab-group>
    @if (!tabs.selected) {
      <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true" class="overview-spinner"></se-fe-spinner>
    }
    @if (canAccess) {
      <div [ngClass]="{ 'overview-hidden-tab': tabs.selected !== 'memberships' }">
        <se-po-membership-list [personaId]="personaId" [access]="access" (hasResults)="membershipsHasResults($event)"></se-po-membership-list>
      </div>
    }
    @if (canAccess) {
      <div [ngClass]="{ 'overview-hidden-tab': tabs.selected !== 'registrations' }">
        <se-po-registration-list [personaId]="personaId" [access]="access" (hasResults)="registrationsHasResults($event)"></se-po-registration-list>
      </div>
    }
    <div [ngClass]="{ 'overview-hidden-tab': tabs.selected !== 'teams' }">
      <se-po-team-list [personaId]="personaId" [access]="access" (hasResults)="teamsHasResults($event)"></se-po-team-list>
    </div>
    <div [ngClass]="{ 'overview-hidden-tab': tabs.selected !== 'organizations' }">
      <se-po-organization-list [personaId]="personaId" [access]="access" (hasResults)="organizationsHasResults($event)"></se-po-organization-list>
    </div>
  </se-fe-card-content>
</se-fe-card>
